import { render, staticRenderFns } from "./noticeManage.vue?vue&type=template&id=44ad6932&scoped=true&"
import script from "./noticeManage.vue?vue&type=script&lang=js&"
export * from "./noticeManage.vue?vue&type=script&lang=js&"
import style0 from "./noticeManage.vue?vue&type=style&index=0&id=44ad6932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad6932",
  null
  
)

export default component.exports